




















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import PicUpload from "@/components/picUpload/index.vue";
@Component({
  name: "imageSetting",
  components: {
    questionSettingTemplate,
    PicUpload,
  },
})
export default class imageSetting extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
    }
  }
  private postForm = {
    url: "",
  };

  private rules = {
    url: [{ required: false }],
  };
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  async validate() {
    return true;
  }
  emitChange() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
}
